import { ColumnFieldType } from '../../enums/index';
import { ColumnFieldTypeObject } from '../ColumnFieldTypeObject';

export class ColumnStringDto extends ColumnFieldTypeObject {
  FormatCallback: (dataDto: object) => string;

  constructor(init?: Partial<ColumnStringDto>) {
    super();
    this.FieldType = ColumnFieldType.String;
    Object.assign(this, init);
  }
}
